import { ProductResourceTypes3P } from '../../ui/configs/types';

const productResourceTypes3PValues = new Set<string>(Object.values(ProductResourceTypes3P));
export const isProductResourceTypes3P = (value: string): value is ProductResourceTypes3P =>
	productResourceTypes3PValues.has(value);
